import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
import {
	IAccessProfileByIdResponse,
	IAccessProfileCreateResquest,
	IAccessProfileQueryRequest,
	IAccessProfileQueryResponse,
	IProfileClaimResponse,
	IProfileResponse,
	IProfiliesClaimsTreeResponse,
	ProfileNewResponseModel
} from "../interfaces/access-profile.interface";
import {
	IResponseData,
	IResponseDataTuple,
	IResponseListData,
	IResponseListDataPaginate
} from "../interfaces/response-data.interface";

@Injectable({
	providedIn: "root"
})
export class AccessProfileService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	getAll(request: IAccessProfileQueryRequest): Observable<IResponseListDataPaginate<IAccessProfileQueryResponse>> {
		let params = new HttpParams();
		if (request.profile !== "" && request.profile !== undefined && request.profile !== null) {
			params = params.append("profile", request.profile);
		}
		if (request.status !== "" && request.status !== undefined && request.status !== null) {
			params = params.append("status", request.status);
		}
		if (request.page !== undefined) {
			params = params.append("page", request.page.toString());
		}
		if (request.pageSize !== undefined) {
			params = params.append("pageSize", request.pageSize.toString());
		}
		return this.http.get<IResponseListDataPaginate<IAccessProfileQueryResponse>>(
			`${environment.urlApi}/access/getprofilebyfilters`,
			{ params }
		);
	}

	getProfilies(isAllActive?: string): Observable<IResponseListData<IProfileResponse>> {
		let params = new HttpParams();
		if (isAllActive !== undefined && isAllActive !== null) {
			params = params.append("isAllActive", isAllActive);
		}
		return this.http.get<IResponseListData<IProfileResponse>>(`${environment.urlApi}/access/GetProfilies`, { params });
	}

	getProfiliesClaims(): Observable<IResponseData<IProfileClaimResponse>> {
		return this.http.get<IResponseData<IProfileClaimResponse>>(`${environment.urlApi}/access/GetProfiliesClaims`);
	}

	getProfiliesClaimsTree(): Observable<IResponseData<IProfiliesClaimsTreeResponse>> {
		return this.http.get<IResponseData<IProfiliesClaimsTreeResponse>>(
			`${environment.urlApi}/access/GetProfiliesClaimsTree`
		);
	}

	getById(id: number): Observable<IResponseData<IAccessProfileByIdResponse>> {
		return this.http.get<IResponseData<IAccessProfileByIdResponse>>(
			`${environment.urlApi}/access/GetProfileById?idProfile=${id}`
		);
	}

	getNewById(id: number): Observable<IResponseData<ProfileNewResponseModel>> {
		return this.http.get<IResponseData<ProfileNewResponseModel>>(
			`${environment.urlApi}/access/GetNewProfileById?idProfile=${id}`
		);
	}

	async getProfiliesClaimLink(link: string) {
		return await this.http
			.get<IResponseDataTuple<IProfileClaimResponse>>(`${environment.urlApi}/access/GetProfileClaimLink?link=${link}`)
			.toPromise();
	}

	update(request: IAccessProfileCreateResquest): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/access/PutProfile`, request);
	}

	post(request: IAccessProfileCreateResquest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/access/PostProfile`, request);
	}
}
